'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useContext, useState } from 'react';
import { useMedia } from 'react-use';

import cx from 'classnames';
import { PreviousPathnameContext } from 'contexts/PreviousPathnameContext';
import { usePathname } from 'next/navigation';
import PropTypes from 'prop-types';

import useDetectTouch from 'hooks/useDetectTouch';
import useScrollDirection from 'hooks/useScrollDirection';

import FavoritesLink from './FavoritesLink';
import FavoritesNotifier from './FavoritesNotifier';
import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';

import styles from './Header.module.scss';

const Header = ({ navigation, headerBottomSlot, popularSearches = [] }) => {
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [isHeaderHover, setIsHeaderHover] = useState(false);

    // Mobile state bubbled up for headerContainer classes
    const [menuOpen, setMenuOpen] = useState(false);
    const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
    const [backFromSearchPanel, setBackFromSearchPanel] = useState(false);

    // Desktop state bubbled up for isHidden computation
    const [activeHoverIndex, setActiveHoverIndex] = useState(-1);

    const isTouch = useDetectTouch();
    const isLarge = useMedia('(min-width: 1024px)', false);
    const scrollDirection = useScrollDirection();

    const isHidden = (() => {
        if (menuOpen) {
            return false;
        }
        if (!isHeaderHover && activeHoverIndex === -1 && !isSearchOpen) {
            return scrollDirection === 'down';
        } else {
            return false;
        }
    })();

    const pathname = usePathname();
    const previousPathname = useContext(PreviousPathnameContext);
    const showIntro = pathname === '/' && !previousPathname;

    const handleHeaderMouseEnter = () => {
        isLarge && !isTouch && setIsHeaderHover(true);
    };

    const handleHeaderMouseLeave = () => {
        isLarge && !isTouch && setIsHeaderHover(false);
    };

    const handleSearchIsOpen = isOpen => {
        setIsSearchOpen(isOpen);
    };

    return (
        <div
            className={cx(styles.headerContainer, {
                [styles.menuOpen]: menuOpen,
                [styles.isHidden]: isHidden,
                [styles.isLanding]: showIntro,
                [styles.isMobileSearchOpen]: isMobileSearchOpen,
                [styles.backFromSearchPanel]: backFromSearchPanel,
            })}
        >
            <header
                className={styles.header}
                onMouseEnter={handleHeaderMouseEnter}
                onMouseLeave={handleHeaderMouseLeave}
            >
                <HeaderMobile
                    navigation={navigation}
                    popularSearches={popularSearches}
                    showIntro={showIntro}
                    onSearchIsOpen={handleSearchIsOpen}
                    onMenuOpenChange={setMenuOpen}
                    onMobileSearchOpenChange={setIsMobileSearchOpen}
                    onBackFromSearchPanelChange={setBackFromSearchPanel}
                />
                <HeaderDesktop
                    navigation={navigation}
                    popularSearches={popularSearches}
                    onSearchIsOpen={handleSearchIsOpen}
                    onActiveHoverChange={setActiveHoverIndex}
                />
                <FavoritesLink isLanding={showIntro} />
            </header>
            {headerBottomSlot && <div data-bottomslot>{headerBottomSlot}</div>}
            <FavoritesNotifier />
        </div>
    );
};

Header.propTypes = {
    navigation: PropTypes.object,
    headerBottomSlot: PropTypes.node,
    popularSearches: PropTypes.arrayOf(PropTypes.string),
};

export default Header;
